module.exports = __webpack_public_path__ + "img/re-invite.350aed24.svg";